/**
 * 项目入口文件
 * 负责初始化 Vue 实例，挂载路由、状态管理和根组件
 */

import Vue from 'vue'                 // 引入 Vue 框架
import App from './App.vue'           // 引入根组件
import router from './router'         // 引入路由配置
import store from './store'           // 引入 Vuex 状态管理

Vue.config.productionTip = false      // 关闭生产环境提示

function emitMessage(root, type, text, duration) {
  if (!root) return
  root.$emit('show-message', { type, text, duration })
}

Object.defineProperty(Vue.prototype, '$message', {
  get() {
    const root = this.$root
    return {
      success(text, duration) {
        emitMessage(root, 'success', text, duration)
      },
      error(text, duration) {
        emitMessage(root, 'error', text, duration)
      },
      info(text, duration) {
        emitMessage(root, 'info', text, duration)
      }
    }
  }
})

Object.defineProperty(Vue.prototype, '$confirm', {
  get() {
    const root = this.$root
    return (options = {}) => new Promise(resolve => {
      if (!root) {
        resolve(false)
        return
      }
      const payload = typeof options === 'string' ? { message: options } : options
      root.$emit('show-confirm', { ...payload, resolve })
    })
  }
})

/**
 * 某些浏览器安装 MetaMask 后，会在页面注入脚本并主动抛出
 * "Failed to connect to MetaMask"。项目本身没有钱包逻辑，这类错误会被
 * webpack dev overlay 当成应用运行时错误盖住页面，因此只过滤该扩展错误。
 */
function isInjectedMetaMaskError(errorLike) {
  const text = [
    errorLike && errorLike.message,
    errorLike && errorLike.reason && errorLike.reason.message,
    errorLike && errorLike.error && errorLike.error.message,
    errorLike && errorLike.filename,
    errorLike && errorLike.reason && errorLike.reason.stack,
    errorLike && errorLike.error && errorLike.error.stack
  ].filter(Boolean).join('\n')

  return text.includes('Failed to connect to MetaMask') ||
    text.includes('nkbihfbeogaeaoehlefnkodbefgpgknn')
}

window.addEventListener('error', event => {
  if (!isInjectedMetaMaskError(event)) return
  event.preventDefault()
  event.stopImmediatePropagation()
}, true)

window.addEventListener('unhandledrejection', event => {
  if (!isInjectedMetaMaskError(event)) return
  event.preventDefault()
  event.stopImmediatePropagation()
}, true)

// 本地开发环境（localhost / 127.0.0.1 / 192.168.x.x）使用本地后端
// localStorage.ip = 'http://192.168.124.52:8088'
// 生产环境使用远程服务器地址
localStorage.ip = 'https://www.ydd3388.net'

localStorage.baseUrl =  localStorage.ip

new Vue({
  router,                             // 注册路由
  store,                              // 注册状态管理
  render: h => h(App)                 // 渲染根组件
}).$mount('#app')                     // 挂载到 DOM 节点 #app
